module.exports = __webpack_public_path__ + "static/img/service_banana04.eaa2964.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/service_banana04.png
// module id = O1ub
// module chunks = 0